module.exports = __webpack_public_path__ + "img/blue-water-wallpaper.990e60f1.jpg";